import * as React from 'react';
import { FieldInputProps } from 'react-final-form';
import { Table } from 'semantic-ui-react';
import { InnerEntityOptions } from 'scenes/Spray/scenes/Diary/components/SprayEventFinalForm/components/SprayEventForm/components/SpraySchemaInnerEntityTableField/components/SpraySchemaInnerEntityOptions/types';
import TableCellTag from 'components/TableCellTag';
import { APPLIED_FERTILIZER_ENTITIES_BY_DATE_LOAD_NAMESPACE } from 'services/appliedFertilizerEntitiesByDate/constants';
import { SPRAYED_ENTITIES_BY_DATE_LOAD_NAMESPACE } from 'services/sprayedEntitiesByDate/constants';
import RenderEntityTableRow from './components/RenderEntityTableRow';
import RenderEntityTableRowVarietyCheckbox from './components/RenderEntityTableRowVarietyCheckbox';

import './styles.scss';

interface Props {
    innerEntityIds: number[];
    innerEntitiesGroupedByVariety?: Record<string, InnerEntityOptions>;
    input: FieldInputProps<any, HTMLElement>;
    namespace:
        | typeof APPLIED_FERTILIZER_ENTITIES_BY_DATE_LOAD_NAMESPACE
        | typeof SPRAYED_ENTITIES_BY_DATE_LOAD_NAMESPACE;
}

export default class RenderEntityTableRows extends React.PureComponent<Props> {
    render(): React.ReactElement | React.ReactElement[] {
        const {
            input,
            innerEntityIds,
            innerEntitiesGroupedByVariety,
            namespace
        } = this.props;

        if (
            !innerEntitiesGroupedByVariety ||
            !innerEntityIds ||
            !innerEntityIds.length
        ) {
            return (
                <Table.Row colSpan="2" textAlign="center">
                    <Table.Cell
                        colSpan="2"
                        className="events-table-cell-padding"
                    >
                        No options.
                    </Table.Cell>
                </Table.Row>
            );
        }

        return (
            <React.Fragment>
                {Object.keys(innerEntitiesGroupedByVariety).map((variety) => (
                    <React.Fragment key={variety}>
                        <Table.Row textAlign="center">
                            <Table.Cell className="events-table-cell-padding">
                                <RenderEntityTableRowVarietyCheckbox
                                    input={input}
                                    innerEntityIds={innerEntitiesGroupedByVariety[
                                        variety
                                    ].map((entity) => entity.value)}
                                />
                            </Table.Cell>
                            <Table.Cell
                                textAlign="left"
                                className="events-table-cell-padding || variety-table-cell"
                                colSpan="3"
                            >
                                <TableCellTag>{variety}</TableCellTag>
                            </Table.Cell>
                        </Table.Row>
                        {innerEntitiesGroupedByVariety[variety].map(
                            (entity): React.ReactElement => (
                                <RenderEntityTableRow
                                    key={entity.value}
                                    entityId={entity.value}
                                    input={input}
                                    namespace={namespace}
                                />
                            )
                        )}
                    </React.Fragment>
                ))}
            </React.Fragment>
        );
    }
}
